import React, { FC, createRef, useEffect, useMemo, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import { find, forEach } from '@dt/fe-utils/dist/lodash'
import { classNames } from '@dt/fe-utils'
import { menuMobx } from 'restaurant'
import CategoryItem from './CategoryItem'
import BoughtProducts from '../../BoughtProducts'
import { BTAndCouponBar } from '../../'
import productStyleController from '@ctrls/productStyleController'
import { advertMobx } from '@mobxStore'
import ScrollController from '@ctrls/scrollController'
import { useHistoryListen, useHistoryNew } from '@utils'
import './index.scss'

// interface
interface IProps {
  type: 'classic' | 'list';
}
/** 广告类型 */
const advertType = 'waterfall'

const ProductList: FC<IProps> = ({ type }) => {
  const [waterfallAdvertMap, setWaterfallAdvertMap] = useState({})
  const { categories, getProductsForSortCategory } = menuMobx
  const { advertInfo, availableAdsMap } = advertMobx
  const advert = advertInfo[advertType] || null
  const advertAdList = availableAdsMap[advertType] || []
  const history = useHistoryNew()
  /** 延迟计算栏加载图片 */
  const lazyTimer = useRef(null)
  const _products = useMemo(() => {
    return getProductsForSortCategory.filter(item => {
      if (menuMobx.isOpenSoldout) {
        return item.saleCnt !== 0
      } else {
        if (item.saleCnt !== 0 || !menuMobx.openFoldSoldout) {
          return true
        } else {
          const isShowSoldOut = !!find(item.categories, categoryNo => menuMobx.foldSoldoutMap?.[categoryNo] === true)
          return isShowSoldOut
        }
      }
    })
  }, [getProductsForSortCategory, menuMobx.foldSoldoutMap])

  // TODO 减少计算次数
  useEffect(() => {
    if (categories.length) {
      const products = menuMobx.products.filter(item => {
        if (menuMobx.isOpenSoldout) {
          return item.saleCnt !== 0
        } else {
          if (item.saleCnt !== 0 || !menuMobx.openFoldSoldout) {
            return true
          } else {
            const isShowSoldOut = !!find(item.categories, categoryNo => menuMobx.foldSoldoutMap?.[categoryNo] === true)
            return isShowSoldOut
          }
        }
      })
      if (history.getRouteInfo().pathname === '/menu') {
        lazyTimer.current = setTimeout(() => {
          productStyleController.lazy(products)
          productStyleController.scroll(ScrollController._top || 0)
        }, 50)
      } else {
        if (lazyTimer.current) {
          clearTimeout(lazyTimer.current)
        }
      }
    }
  }, [categories, menuMobx.foldSoldoutMap])

  useHistoryListen((pathname) => {
    if (!['/menu'].includes(pathname)) {
      if (lazyTimer.current) {
        clearTimeout(lazyTimer.current)
      }
      return
    }
  })

  /** 瀑布流广告 */
  const setMenuWaterfallAdvert = () => {
    const adLen = advertAdList?.length
    const prodLen = _products?.length
    const queueType = advert?.extInfo?.queueType || 'auto'
    const advertKeys = queueType === 'auto'
      ? (advert?.extInfo?.queueData?.[queueType] || []).slice(0, adLen)
      : advertAdList?.map((item) => item.wfQueue)
    const advertMap: { [key: string]: any[] } = {}
    forEach(advertKeys, (item: number, index: number) => {
      let key = item
      // 当如果添加key超过商品总数，就放到最后
      if (item >= prodLen) {
        key = prodLen
      }
      const thisProduct = _products?.[key - 1]
      const no = thisProduct?.no || 0
      const cno = thisProduct?.categoryNo || 0
      const noKey = thisProduct ? `${cno}${no}` : 0
      advertMap[noKey] = [
        ...advertMap[noKey] || [],
        advertAdList[index]
      ]
    })
    setWaterfallAdvertMap(advertMap)
  }
  useEffect(() => {
    setMenuWaterfallAdvert()
  }, [_products])
  return (
    <div
      className={classNames('product-list menu-product-wrapper', type)}
    >
      <BTAndCouponBar />
      <BoughtProducts />
      {
        categories.length ? (
          categories.map((category) => {
            return (
              <CategoryItem
                type={type}
                advertMap={waterfallAdvertMap}
                key={category.no}
                category={category}
              />
            )
          })
        ) : null
      }
    </div>
  )
}

export default observer(ProductList)
